// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import DoingRoundSvg from '@rsuite/icon-font/lib/status/DoingRound';
var DoingRound = createSvgIcon({
  as: DoingRoundSvg,
  ariaLabel: 'doing round',
  category: 'status',
  displayName: 'DoingRound'
});
export default DoingRound;